'use client';
import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import useDebounceValue from '../../helpers/use-debounce';
import { fetchSearchUsers } from './fetch-search-users';

type Props = {
  isOpen: boolean;
  term: string | null;
};

export const useSearchUsersAutocomplete = (props: Props) => {
  const { isOpen, term } = props;

  const termDebounced = useDebounceValue(term, 400);

  const { client } = useApi();

  return useSWR(
    () => (isOpen ? ['search-users-autocomplete', termDebounced] : null),
    ([_, term]) => fetchSearchUsers(client, term)
  );
};
